/**
 * APEX v8.12 — Logger
 *
 * Logger custom qui no-op en production.
 * En dev : passe à console.* normalement.
 * En prod : silencieux pour log.debug/log.info, garde log.error pour Sentry-like.
 *
 * Usage :
 *   import { log } from '../lib/logger';
 *   log.debug('[Riot] fetched matches:', matches.length);
 *   log.warn('[champions] using fallback version');
 *   log.error('[supabase] insert failed:', error);
 */

const isProd = import.meta.env?.PROD ?? false;

export const log = {
  debug: isProd ? () => {} : console.log.bind(console),
  info:  isProd ? () => {} : console.info.bind(console),
  warn:  console.warn.bind(console),
  error: console.error.bind(console),
};

export default log;
